import { connect } from 'react-redux';
import {
  getReusableTransformListing,
  setContextualSupport,
  unsetContextualSupport,
} from '../../actions';
import { GET_CODE_CONTAINER_LISTING_REQUEST } from '../../constants/actionTypes';
import { getReusableTransformListingEntities } from '../../reducers/selectors';

import ViewReusableTransforms from './ViewReusableTransforms';

const mapStateToProps = (state) => {
  const {
    app: {
      listing: { selectedCardId, aclQueryMode },
    },
    entities: { transforms },
    transforms: { listingTransformType },
    request,
  } = state;

  const data = getReusableTransformListingEntities(state);
  const selectedCardData = selectedCardId && transforms[selectedCardId];
  const isLoading = !!request[GET_CODE_CONTAINER_LISTING_REQUEST];

  return {
    data,
    selectedCardData,
    isLoading,
    listingTransformType,
    aclQueryMode,
  };
};

export default connect(mapStateToProps, {
  getReusableTransformListing,
  setContextualSupport,
  unsetContextualSupport,
})(ViewReusableTransforms);
